@if (!showAnimation() && (coinflip().fe_status === 'open' ||
coinflip().fe_status === 'joining' || coinflip().fe_status === 'finished')) {
<app-coinflip-coin
  class="base-coin"
  [side]="coinflip().winner?.side ?? 1"
  [class.opacity-20]="true"
/>
}
<!--
  Canvas-driven spin replaces the old CSS-bg-image animation. The component
  draws each frame from a pre-loaded ImageBitmap of the sprite atlas
  (CoinflipSpritesService) using `drawImage(bitmap, sx, sy, …)` per rAF tick.
  The atlas is decoded once at app boot, so every tile is a cheap GPU blit
  instead of the per-tile lazy rasterize the old approach paid on first view.
-->
<canvas
  #coinCanvas
  class="coin-canvas"
  [class.coin-canvas--playing]="showAnimation()"
  aria-hidden="true"
></canvas>
@if (coinflip().fe_status === 'countdown') {
<div @fadeInAnimation class="coinflip-timer">
  {{ coinflip().timer ?? 3 }}
</div>
}
